'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { twMerge } from 'tailwind-merge'

export interface LinkTabItemProps {
  href: string
  children: React.ReactNode
  className?: string
  disabled?: boolean
}

export const LinkTabItem = ({
  href,
  children,
  className,
  disabled = false,
}: LinkTabItemProps) => {
  const pathname = usePathname()
  const isActive = pathname === href

  return (
    <li
      className={twMerge(
        'py-2 px-4 text-sm text-gray-500 border-gray-200',
        isActive &&
          'pointer-events-none text-gray-900 font-semibold border-b border-gray-900',
        disabled && 'cursor-not-allowed',
        className
      )}
    >
      {disabled ? (
        <span className="flex items-center gap-2">{children}</span>
      ) : (
        <Link href={href} className="flex items-center gap-2">
          {children}
        </Link>
      )}
    </li>
  )
}
